<template>
  <el-card>
    <div class="formBox">
      <el-form label-position="left" label-width="100px" :model="formData" :rules="rules">
        <el-form-item :label="$t('头像')" prop="portrait">
          <pic-upload :action="$api.file.upload" v-model="formData.portrait" :downloadUrl="$api.file.downloadImg" />
        </el-form-item>

        <el-form-item :label="$t('昵称')" prop="nickname">
          <el-input :placeholder="$t('昵称')" v-model="formData.nickname" />
        </el-form-item>

        <el-form-item :label="$t('手机号')" prop="phone">
          <el-input :placeholder="$t('手机号')" v-model="formData.phone" />
        </el-form-item>

        <el-form-item :label="$t('邮箱')">
          <el-input :placeholder="$t('邮箱')" v-model="formData.email" />
        </el-form-item>

        <el-form-item :label="$t('用户来源')">
          <el-input :placeholder="$t('用户来源')" v-model="formData.source" disabled />
        </el-form-item>

        <el-form-item :label="$t('推广用户数')">
          <el-input :placeholder="$t('推广用户数')" v-model="formData.promoteCount" disabled />
        </el-form-item>

        <el-form-item :label="$t('用户禁用状态')">
          <el-switch inactive-value="no" active-value="yes" v-model="formData.userBandStatus" />
        </el-form-item>

        <el-form-item :label="$t('发布菜谱禁用状态')">
          <el-switch inactive-value="no" active-value="yes" v-model="formData.releaseCookbookBandStatus" />
        </el-form-item>
        <el-form-item :label="$t('发布社区动态/社区评论/菜谱评论禁用状态')">
          <el-switch inactive-value="no" active-value="yes" v-model="formData.releaseTrendsCommentBandStatus" />
        </el-form-item>
        <el-form-item :label="$t('举报功能禁用状态')">
          <el-switch inactive-value="no" active-value="yes" v-model="formData.reportBandStatus" />
        </el-form-item>

        <el-form-item :label="$t('上架菜谱数')">
          <el-input :placeholder="$t('上架菜谱数')" v-model="formData.upCount" disabled />
        </el-form-item>

        <el-form-item :label="$t('仓库菜谱数')">
          <el-input :placeholder="$t('仓库菜谱数')" v-model="formData.draftCount" disabled />
        </el-form-item>
        <el-form-item :label="$t('审核中菜谱书')">
          <el-input :placeholder="$t('审核中菜谱书')" v-model="formData.auditCount" disabled />
        </el-form-item>
        <el-form-item :label="$t('浏览菜谱数')">
          <el-input :placeholder="$t('浏览菜谱数')" v-model="formData.watchCount" disabled />
          <el-input :placeholder="$t('浏览菜谱数')" v-model="formData.baseWatchCbCount" />
        </el-form-item>
        <el-form-item :label="$t('收藏菜谱数')">
          <el-input :placeholder="$t('收藏菜谱数')" v-model="formData.collectCount" disabled />
          <el-input :placeholder="$t('收藏菜谱数')" v-model="formData.baseCollectCbCount" />
        </el-form-item>
        <el-form-item :label="$t('使用菜谱数')">
          <el-input :placeholder="$t('使用菜谱数')" v-model="formData.useCount" disabled />
          <el-input :placeholder="$t('使用菜谱数')" v-model="formData.baseUseCbCount" />
        </el-form-item>
        <el-form-item :label="$t('评价菜谱数')">
          <el-input :placeholder="$t('评价菜谱数')" v-model="formData.commentCount" disabled />
        </el-form-item>
        <el-form-item :label="$t('购买菜谱数')">
          <el-input :placeholder="$t('购买菜谱数')" v-model="formData.buyCount" disabled />
        </el-form-item>
        <el-form-item :label="$t('打赏菜谱数')">
          <el-input :placeholder="$t('打赏菜谱数')" v-model="formData.rewardCount" disabled />
        </el-form-item>
        <el-form-item :label="$t('销售菜谱数')">
          <el-input :placeholder="$t('销售菜谱数')" v-model="formData.sellCount" disabled />
        </el-form-item>
        <el-form-item :label="$t('收获打赏数')">
          <el-input :placeholder="$t('收获打赏数')" v-model="formData.getRewardCount" disabled />
        </el-form-item>
        <el-form-item :label="$t('动态数')">
          <el-input :placeholder="$t('动态数')" v-model="formData.dynamicsCount" disabled />
        </el-form-item>
        <el-form-item :label="$t('动态评论数')">
          <el-input :placeholder="$t('动态评论数')" v-model="formData.dynamicsCommentCount" disabled />
        </el-form-item>
        <el-form-item :label="$t('关注数')">
          <el-input :placeholder="$t('关注数')" v-model="formData.focusCount" disabled />
          <el-input :placeholder="$t('关注数')" v-model="formData.baseFocusCount" />
        </el-form-item>
        <el-form-item :label="$t('粉丝数')">
          <el-input :placeholder="$t('粉丝数')" v-model="formData.fanCount" disabled />
          <el-input :placeholder="$t('粉丝数')" v-model="formData.baseFansCount" />
        </el-form-item>
        <el-form-item :label="$t('获赞数')">
          <el-input :placeholder="$t('获赞数')" v-model="formData.dynamicsLikeCount" disabled />
          <el-input :placeholder="$t('获赞数')" v-model="formData.baseLikeCount" />
        </el-form-item>
      </el-form>
    </div>
      <div class="btn">
        <el-button type="primary" @click="handleSubmit">{{ $t('保存') }}</el-button>
        <el-button @click="handleReset">{{ $t('重置') }}</el-button>
      </div>
  </el-card>
</template>

<script>
import {request} from "@/config/request";
import PicUpload from "@/components/pic-upload/PicUpload.vue";
import {filterParams} from "@/utils/common";
export default {
  name: "UserEdit",
  components: {PicUpload},
  data() {
    return {
      formData: {},
      rules: {
        nickname: [{required: true, message: this.$t('请输入昵称'), trigger: 'blur'}],
        phone: [{required: true, message: this.$t('请输入手机号'), trigger: 'blur'}],
        portrait: [{required: true, message: this.$t('请上传头像'), trigger: 'chang'}],
      }
    }
  },
  methods: {
    // 提交
    async handleSubmit() {
      try {
        const params = {...this.formData};
        delete params.createTime;
        delete params.updateTime;
        delete params.type;
        delete params.lastLoginTime;
        delete params.registerTime;
        delete params.birthday;

        await request(this.$api.anUser.updateStatus, filterParams(params));
        this.$message.success(this.$t('保存成功'));
        this.$router.back();
      } catch (e) {
        console.log(e);
      }
    },


    formatData(time) {
      if(!time) return time;
      return this.$moment(time).format("YYYY-MM-DD HH:mm:ss");
    },


    // 详情
    async handleLoadDetail() {
      try {
        let res = await request(this.$api.anUser.detail, this.$route.query);
        this.formData = res.anUser;
      }catch(e) {
         console.log(e);
      }
    },
    // 重置
    handleReset() {
      this.handleLoadDetail();
    }
  },
  created() {
    this.handleLoadDetail();
  }
}
</script>

<style scoped>

.el-form {
  max-width: 600px;
}
.btn{
margin-top: 50px;
}

.formBox{
  width: 100%;
  height: 750px;
  overflow-y: auto;
}
</style>
